// 単体テストで確認するので無効化しても問題ない
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import axios from 'axios';

/**
 * 対象がobjectか返す
 * @param target 調査対象
 * @returns true：object / false: null or object以外
 */
// eslint-disable-next-line @typescript-eslint/ban-types
const isObject = (target: any): target is object =>
  typeof target === 'object' && target !== null;

/**
 * 参考：https://stackoverflow.com/questions/2970525/converting-any-string-into-camel-case
 * @param str スネークケースをキャメルケースに変更する
 * @returns スネークケースをキャメルケースに変換したもの
 */
const convertSnakeCaseToCamelCase = (str: string | undefined): string => {
  if (str === undefined) {
    return '';
  }
  const camelCaseStr = str
    .replace(/(_.)/g, (word, index) =>
      index === 0 ? word.toLowerCase() : word.toUpperCase(),
    )
    .replace(/_/g, '');

  return camelCaseStr;
};

/**
 * キーの値をスネークケースからキャメルケースに変換して返す
 * @param data 変換対象のobject
 * @returns キーの値をスネークケースからキャメルケースに変換して返す
 */
const mapKeysToCamelCase = (data: unknown): Record<string, unknown> => {
  const obj = data as Record<string, unknown>;

  const keyValues = Object.keys(obj).map((key) => {
    const newKey = convertSnakeCaseToCamelCase(key) || key;

    return { [newKey]: obj[key] };
  });

  const newObject = keyValues.reduce((result, current) => {
    const keys = Object.keys(current);
    if (keys.length === 0) {
      return result;
    }
    const key = keys[0];
    result[key] = current[key];

    return result;
  }, {});

  return newObject;
};

/**
 * 参考：https://chikuwa-parfait.tumblr.com/post/132911132328/map%E3%82%84reduce%E3%81%AA%E3%81%A9%E3%81%AE%E9%96%A2%E6%95%B0%E3%82%92%E8%87%AA%E4%BD%9C%E3%81%99%E3%82%8B/amp
 * valueの値をcallbackを適用したもので置き換える。
 * @param data 変換する対象
 * @param callback 使用するコールバック関数
 * @returns vauleの値を変更したobject
 */
const mapValues = (data: unknown, callback: any): Record<string, unknown> => {
  const obj = data as Record<string, unknown>;
  const keys = Object.keys(obj);
  const result: Record<string, unknown> = {};
  for (let i = 0, len = keys.length; i < len; i += 1) {
    result[keys[i]] = callback(obj[keys[i]], keys[i]);
  }

  return result;
};

const responseMapKeysDeep = (data: unknown, callback: any): unknown => {
  if (Array.isArray(data)) {
    return data.map((innerData) => responseMapKeysDeep(innerData, callback));
  }
  if (isObject(data)) {
    return mapValues(mapKeysToCamelCase(data), (val: unknown) =>
      responseMapKeysDeep(val, callback),
    );
  }

  return data;
};

const mapKeysCamelCase = (data: unknown): unknown =>
  responseMapKeysDeep(data, (_value: unknown, key: string | undefined) =>
    convertSnakeCaseToCamelCase(key),
  );

const baseURL = `${
  process.env.REACT_APP_API_DOMAIN ?? 'http://localhost:3000'
}`;

const customAxios = axios.create({ baseURL });
customAxios.interceptors.response.use(
  (response) => {
    const { data } = response;
    const convertedData = mapKeysCamelCase(data);

    return { ...response, data: convertedData };
  },
  (error) => Promise.reject(error),
);

export default customAxios;
